import ScrollHorizontal from './ScrollHorizontal';
import ScrollVertical from './ScrollVertical';


export default {
  Horizontal: ScrollHorizontal,
  Vertical: ScrollVertical,
};
